<template>
  <v-list-item
    class="pl-0"
    :disabled="item.data.category == 'Structure'"
    @click="$emit('clickElement', item)"
  >
    <template #prepend>
      <v-avatar size="24" :color="item.data.color" class="mr-2">
        <v-icon size="16">{{ item.data.icon }}</v-icon>
      </v-avatar>
    </template>
    <v-list-item-title>{{ item.data.aliasName }}</v-list-item-title>
    <v-list-item-subtitle>{{ item.data.name }}</v-list-item-subtitle>
    <template #append>
      <v-icon
        size="20"
        color="success"
        v-if="item.data.bindings || item.data.category == 'Structure'"
      >
        mdi-check-circle
      </v-icon>
      <v-icon size="20" color="grey" v-else> mdi-close-circle </v-icon>
    </template>
  </v-list-item>
</template>

<script setup>
defineProps(["item"]);
</script>

<style scoped></style>
